<template>
  <div id="popUpWin">
    <div>
      <div class="cross" v-on:click="closePopUp">
        <cross-icon/>
      </div>
      <div>
        <h1>Новая карта</h1>
        <p class="miscTitle">Введите данные карты для списания платежей</p>
      </div>

      <text-input :label="'Номер карты'"/>
      <text-input :label="'Имя держателя карты'"/>
      <div class="cvc">
        <text-input :label="'Месяц / Год'"/>
        <text-input :label="'CVC / CVV'"/>
      </div>

      <div class="docCheck">
        <checkbox-input/>
        <p>Даю согласие на <a>обработку персональных данных ФИНМОЛЛ</a></p>
      </div>
      <div class="docCheck">
        <checkbox-input/>
        <p>Даю согласие на <a>соглашение об использовании аналога собственноручной подписи</a></p>
      </div>
      <div class="docCheck">
        <checkbox-input/>
        <p>Я ознакомился и даю согласие с <a>договором-офертой</a></p>
      </div>

    </div>

    <button class="whiteButton">Добавить карту</button>

  </div>
</template>

<script>
import CrossIcon from '@/assets/svg/cross';
import TextInput from '@/components/Form/text-input';
import CheckboxInput from '@/components/Form/checkbox-input';
export default {
  name: 'add-card-form',
  components: { CheckboxInput, TextInput, CrossIcon },
  methods: {
    closePopUp () {
      this.$store.commit('closePopUp');
    }
  }
};
</script>

<style scoped>
#popUpWin { display: flex; flex-direction: column; justify-content: space-between }
#popUpWin>div { margin-bottom: 6.67vw }
#popUpWin h1 { margin-bottom: 2.13vw }
#popUpWin .miscTitle { margin-bottom: 6.40vw }
#popUpWin .cvc { display: flex; margin-bottom: 6.40vw }
#popUpWin .kariInput { margin-bottom: 2.13vw  }
#popUpWin .cvc>.kariInput:first-child { margin-right: 2.13vw  }
#popUpWin .docCheck { display: flex  }
#popUpWin .docCheck>p { font-size: 4vw  }
#popUpWin .whiteButton { padding: 2.67vw 0; color: rgba(240, 240, 240, 1); background-color: rgba(191, 191, 191, 1); border: none }
a { color: rgba(153, 30, 102, 1) }
@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #popUpWin { width: calc(600px - 40px) }
  #popUpWin>div { margin-bottom: 34px }
  #popUpWin h1 { margin-bottom: 20px }
  #popUpWin .miscTitle { margin-bottom: 20px }
  #popUpWin .cvc { display: flex; margin-bottom: 34px }
  #popUpWin .kariInput { margin-bottom: 20px  }
  #popUpWin .cvc>.kariInput:first-child { margin-right: 20px  }
  #popUpWin .docCheck { display: flex  }
  #popUpWin .docCheck>p { font-size: 15px  }
  #popUpWin .whiteButton { padding: 10px 0; color: rgba(240, 240, 240, 1); background-color: rgba(191, 191, 191, 1); border: none }
}

</style>
